module.exports = __webpack_public_path__ + "img/857.5b099a89.png";